import EventBus from "../event-bus";
const sendMessageError = new EventBus<Record<string, any>>("sendMessageError");

export default sendMessageError;
